import React from "react";
import * as ImSdk from "../../../imsdk/api";
import { StyleSheet, View } from "react-native";
import { color_333333, white } from "../../assets/style/colors";
import { ChatType } from "../../constants/types";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { userAvatarSize } from "./components/ChatDetailUser";
import { Topic } from "../../../imsdk/db/t_topic";
import { SingleChatDetail } from "./SingleChatDetail";
import time from "../../../imsdk/time";
import { showToast } from "../../components/Toast";
import { MainNavProps, MainParamList } from "../navigation/main/MainParamList";
import { useChatStore } from "../../store/ChatStore";
import { Str_OperationFailed, } from "../../language/string_res";
import { GroupChatDetail } from "./group/GroupChatDetail";

export interface ChatDetailProps {
    navigation: NativeStackNavigationProp<MainParamList, "ChatDetail">
}

//静音
export function handleMuteTopic(topic: Topic, isMute: boolean, setIsMute: (isMute: boolean) => void) {
    ImSdk.getInstance().SetTopicProps({ tid: topic.tid, mute: isMute }).then(
        (res) => {
            if (res.error) {
                showToast(Str_OperationFailed);
                setTimeout(() => {
                    setIsMute(!isMute);
                }, 300);
            }
        }
    );
}

//置顶
export function handleToTopTopic(topic: Topic, isTop: boolean, setIsTop: (isTop: boolean) => void) {
    const t = time.toUnixMillSecond(time.now());
    const order = isTop ? t : 0;
    ImSdk.getInstance().SetTopicProps({ tid: topic.tid, order: order }).then((res) => {
        if (res.error) {
            showToast(Str_OperationFailed);
            setTimeout(() => {
                setIsTop(!isTop);
            }, 300);
        }
    });
}


export const ChatDetail = ({ navigation, route }: MainNavProps<"ChatDetail">) => {
    const { chatState } = useChatStore();
    const topic = chatState?.curTopicWithSummary?.topic
    if (!topic) {
        return null;
    }

    return (
        <View style={{ flex: 1 }}>
            {topic.type === ChatType.GROUP ? (
                <GroupChatDetail
                    navigation={navigation} />
            ) : (
                <SingleChatDetail
                    navigation={navigation} />
            )}
        </View>
    );
};

export const singleStyles = StyleSheet.create({
    userCard: {
        backgroundColor: white,
        display: "flex",
        alignItems: "center",
        marginTop: 1
    },
    chatItem: {
        marginRight: 18,
        marginTop: 20,
    },
    moreIcon: {
        // height: userAvatarSize,
        display: "flex",
        width: 24,
        alignItems: "center",
        justifyContent: "center"
    },
    add: {
        width: userAvatarSize,
        height: userAvatarSize,
        marginLeft: 20
    },
    control: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row"
    },
    controlText: {
        marginLeft: 12,
        fontSize: 16,
        color: color_333333
    },
    quitGroup: {
        backgroundColor: white,
        paddingHorizontal: 16,
        paddingBottom: 20,
        paddingTop: 12
    }
});
